export default "__VITE_ASSET__yKhi5RTR__"